import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CardBlockTags = ({ tags, color = 'accent0' }) => (
  <div className={classnames('tags', `tags_${color}`)}>
    {
      tags && tags.map(tag => <div className={classnames("tags__item", `tags__item--rect tags__item--rect--${color}`)} key={tag}>{ tag }</div>)
    }
  </div>
);

CardBlockTags.propTypes = {
  color: PropTypes.string,
  tags: PropTypes.array,
};

export default CardBlockTags;